/**
 * Created by Prarsol on 2016/5/16.
 */
import React from 'react';
import { Button, Input, Modal, Select, Table, Tooltip } from 'antd';
import RegionalMaintenance from './RegionalMaintenance';
import RoomQrModal from './RoomQrModal';
import RoomDeviceModal from './RoomDeviceModal';
import RoomMaintainModal from './RoomMaintainModal';
import RoomEditor from './RoomEditor';
import CmmaDevice from './CmmaDevice';
import IconTip from '../IconTip';
import moment from 'moment';
import { OperateSpan } from '../Widgets';
import { MAINTAIN_STATUS, ROLES_KEY, ROOM_CAPACITY, SEMICOLON } from '../../utils/constants';
import { injectIntl } from 'react-intl';

//会议室管理
class RoomManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentRoomInfo: {},
      selectedRoomIds: [],
      selectedManager: '',
      name: '',
      nameEn: '',
      zoneId: 0,
      showQr: false,
      showDevice: false,
      showMaintain: false
    };
    this.bindRoomsManager = this.bindRoomsManager.bind(this);
  }

  componentWillMount() {}

  componentWillReceiveProps(props) {}

  bindRoomsManager() {
    const { selectedManager, selectedRoomIds } = this.state;
    this.props.dispatch({
      type: 'account/bindMangerToRooms',
      payload: { manager: selectedManager, roomIds: selectedRoomIds }
    });
  }

  render() {
    const { showQr, showDevice, showMaintain, currentRoomInfo } = this.state;
    const {
      dispatch,
      rooms,
      areaData,
      allAreaDataNoPermission,
      nodeLength,
      titleState,
      intl,
      meetingManagers,
      showEditRoomModal,
      showCmmaDeviceModal,
      cmmaDeviceInfo,
      currentUser,
      meetingPolicy
    } = this.props;
    const {locale} = intl;
    const {maintainSwitch = 1} = meetingPolicy;
    const columns = [
      {
        title: intl.formatMessage({ id: 'room_manage_list_name' }),
        width: '20%',
        key: 'name',
        render: record => {
          return <span>{locale === "en_US"?record.nameEn:record.name}</span>;
        }
      },
      {
        title: intl.formatMessage({ id: 'room_manage_list_zoneFullName' }),
        width: '20%',
        dataIndex: 'zoneFullName'
      },{
        title: intl.formatMessage({ id: 'room_manage_list_adminUserName' }),
        width: '17%',
        dataIndex: 'adminUserName'
      }];
      if(1 == maintainSwitch) {
        columns.push({
          title: intl.formatMessage({id: 'room_manage_repair'}),
          width: '15%',
          render: record => {
            const timeNow = moment();
            if(record.maintainStatus > MAINTAIN_STATUS.not_set
              && moment(record.startMaintainTime).isBefore(timeNow)
                &&  moment(record.endMaintainTime).isAfter(timeNow)) {
              return <div>
                <Tooltip title={<div>
                  <div>{moment(record.startMaintainTime).format('YYYY-MM-DD HH:mm')}</div>
                  <div>{moment(record.endMaintainTime).format('YYYY-MM-DD HH:mm')}</div>
                </div>}>
                  <span style={{color: '#4680FF'}}>{intl.formatMessage({id: 'room_maintain_status_valid'})}</span>
                </Tooltip>
              </div>
            } else {
              return <div>
                <span>{intl.formatMessage({id: 'room_maintain_status_normal'})}</span>
              </div>
            }
          }
        });
      }
        // 是否启用
        columns.push({
          title: intl.formatMessage({ id: 'room_manage_list_visible' }),
          width: '10%',
          key: 'visible',
          render:record => {
            const {visible = 0} = record;
            return <span style={visible === 0?{color:'#4680FF'}:{color:'gray'}}>
              {visible===0?'启用':'下线'}
            </span>;
          }
        });
        columns.push({
            title: intl.formatMessage({ id: 'room_manage_list_oprate' }),
            width: '18%',
            key: 'operate',
            render: record => {
              const { deviceIds = '', capacity, cmmaRoomId, adminUserId } = record;
              return (
                <div>
                  <OperateSpan onClick={this.onShowDevice.bind(this, record)}>
                    <IconTip
                      disabled={!deviceIds}
                      title={
                        deviceIds
                          ? intl.formatMessage({ id: 'room_manage_device_repair' })
                          : intl.formatMessage({
                              id: 'room_manage_no_device_repair'
                            })
                      }
                      type="weihu"
                    />
                  </OperateSpan>
                  <OperateSpan
                    onClick={() => {
                      this.state.currentRoomInfo = record;
                      this.setState(this.state);
                      dispatch({
                        type: 'account/update',
                        payload: { showEditRoomModal: true }
                      });
                    }}
                  >
                    <IconTip
                      title={intl.formatMessage({ id: 'modal_manage_edit' })}
                      type="75bianji"
                    />
                  </OperateSpan>
                  <OperateSpan
                    onClick={() => {
                      Modal.confirm({
                        title: '',
                        content: intl.formatMessage({
                          id: 'room_manage_delete_msg'
                        }),
                        okText: intl.formatMessage({ id: 'modal_manage_btn_ok' }),
                        cancelText: intl.formatMessage({
                          id: 'modal_manage_btn_cancel'
                        }),
                        onOk: () => {
                          dispatch({
                            type: 'account/deleteRome',
                            roomId: record.id,
                            name: this.state.name
                          });
                        }
                      });
                    }}
                  >
                    <IconTip
                      title={intl.formatMessage({ id: 'modal_manage_delete' })}
                      type="shanchu"
                    />
                  </OperateSpan>
                  {1 == maintainSwitch && (currentUser.roleKey == ROLES_KEY.admin ||
                    (currentUser.roleKey == ROLES_KEY.room_admin &&
                      (currentUser.userId === adminUserId || adminUserId.startsWith(currentUser.userId + SEMICOLON)
                        || adminUserId.endsWith(SEMICOLON + currentUser.userId) || adminUserId.indexOf(SEMICOLON + currentUser.userId + SEMICOLON) !== -1))) && (
                    <OperateSpan onClick={this.onShowMaintain.bind(this, record)}>
                      <IconTip
                        title={intl.formatMessage({ id: 'room_manage_repair'})}
                        type="maintain"
                      />
                    </OperateSpan>
                  )}
                  {capacity === ROOM_CAPACITY.cisco_cmma && (
                    <OperateSpan
                      onClick={() => {
                        dispatch({ type: 'account/getCmmaDevice', cmmaRoomId });
                      }}
                    >
                      <IconTip
                        title={intl.formatMessage({ id: 'room_manage_video_bind' })}
                        type="shipin2"
                      />
                    </OperateSpan>
                  )}
                </div>
              );
            }
          });


    const rowSelection = {
      selectedRowKeys:this.state.selectedRoomIds,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRoomIds: selectedRowKeys });
      },
      getCheckboxProps: record => ({
        disabled: record.visible === 1,
        name: record.id
      })
    };

    let meetingMangerOpts = [];
    meetingManagers.map(item => {
      meetingMangerOpts.push(
        <Select.Option key={item.userId}>{item.displayName}</Select.Option>
      );
    });

    let currentZoneId = '',
      currentParkId = '',
      zoneId = this.state.zoneId;
    if (zoneId && zoneId > 0) {
      if (allAreaDataNoPermission) {
        allAreaDataNoPermission.child &&
          allAreaDataNoPermission.child.map(a => {
            if (a.id == zoneId) {
              currentParkId = a.id;
            }
          });
        if (!currentParkId) {
          allAreaDataNoPermission.child &&
            allAreaDataNoPermission.child.map(a => {
              if (a.child && a.child.some(c => c.id == zoneId)) {
                currentParkId = a.id;
                currentZoneId = zoneId;
              }
            });
        }
      }
    }
    return (
      <div className="room_manage_div">
        <RoomEditor
          show={showEditRoomModal}
          locale={this.props.locale}
          roomInfo={this.state.currentRoomInfo}
          cancelHandle={() => {
            dispatch({
              type: 'account/update',
              payload: { showEditRoomModal: false }
            });
          }}
          saveHandle={({ roomInfo, resolve, reject }) => {
            this.setState({ currentRoomInfo: roomInfo });
            dispatch({
              type: 'account/saveRoomInfo',
              payload: {
                roomInfo: roomInfo,
                name: this.state.name,
                zoneId: this.state.zoneId,
                resolve,
                reject
              }
            });
          }}
          {...this.props}
        />
        <CmmaDevice
          show={showCmmaDeviceModal}
          dispatch={dispatch}
          cmmaDeviceInfo={cmmaDeviceInfo}
          cancelHandle={() => {
            dispatch({
              type: 'account/updateCmmaDeviceInfo',
              showCmmaDeviceModal: false,
              cmmaDeviceInfo: {}
            });
          }}
          deleteHandle={cmmaRoomId => {
            const promise = new Promise((resolve, reject) => {
              dispatch({
                type: 'account/deleteCmmaDevice',
                resolve,
                reject,
                cmmaRoomId
              });
            });
            promise.then(
              () => {
                Modal.success({
                  content: intl.formatMessage({
                    id: 'room_manage_video_delete_ok'
                  })
                });
              },
              () => {
                Modal.error({
                  content: intl.formatMessage({
                    id: 'room_manage_video_delete_fail'
                  })
                });
              }
            );
          }}
        />
        <div className="left_div">
          {/*<div className="left_head">会议室管理列表</div>*/}
          {allAreaDataNoPermission &&
            Object.keys(allAreaDataNoPermission).length > 0 && (
              <RegionalMaintenance
                intl={intl}
                nodeLength={nodeLength}
                allAreaData={allAreaDataNoPermission}
                areaData={areaData}
                dispatch={dispatch}
                local={intl.formatMessage({ id: 'locale' })}
                titleState={titleState}
                parentZoneId={allAreaDataNoPermission.id}
                findRoomsFun={zoneId => {
                  this.setState({ zoneId });
                  this.props.dispatch({
                    type: 'account/findRooms',
                    payload: { zoneId, name: this.state.name }
                  });
                }}
              />
            )}
        </div>
        <div className="center_div" />
        <div className="right_div">
          <div className="right_head">
            <div className="room_manage_button_div">
              <div className="buttons_left_div">
                <Button
                  type="primary"
                  icon="plus"
                  className="room_manage_button"
                  style={{backgroundColor:'#4680FF',borderColor:'#4680FF'}}
                  onClick={() => {
                    this.setState({
                      currentRoomInfo: Object.assign(
                        {},
                        RoomEditor.roomDefaultState,
                        {
                          zoneId: currentZoneId,
                          parkId: currentParkId
                        }
                      )
                    });
                    dispatch({
                      type: 'account/update',
                      payload: { showEditRoomModal: true }
                    });
                  }}
                >
                  {intl.formatMessage({ id: 'room_manage_add_meeting_room' })}
                </Button>
                <Button
                  type="primary"
                  className="room_manage_button"
                  style={{backgroundColor:'#FFFFFF',color:'#4680FF',borderColor:'#4680FF'}}
                  onClick={() => {
                    if(this.state.selectedRoomIds.length == 0){
                      Modal.warn({
                        title: '',
                        content: intl.formatMessage({
                          id: 'room_manage_offRoomSelect_msg'
                        }),
                        okText: intl.formatMessage({ id: 'modal_manage_btn_ok' }),
                        cancelText: intl.formatMessage({
                          id: 'modal_manage_btn_cancel'
                        }),
                      });
                    }else {
                      Modal.confirm({
                        title: '',
                        content: intl.formatMessage({
                          id: 'room_manage_offline_msg'
                        }),
                        okText: intl.formatMessage({ id: 'modal_manage_btn_ok' }),
                        cancelText: intl.formatMessage({
                          id: 'modal_manage_btn_cancel'
                        }),
                        onOk: () => {
                          const promise = new Promise((resolve, reject) => {
                            dispatch({
                              type: 'account/offLineRooms',
                              roomIds: this.state.selectedRoomIds,
                              name: this.state.name,
                              resolve,
                              reject
                            });
                          });
                          promise.then(()=>{
                            Modal.success({ content: intl.formatMessage({id:'meeting_room_off_success'}), okText: intl.formatMessage({id:'room_edit_ok'})});
                            this.setState({selectedRoomIds:[]});
                          },msg=>{
                            Modal.error({ content: msg });
                          });
                        }
                      });
                    }
                  }}
                >
                  {intl.formatMessage({ id: 'room_manage_Enable_meeting_room' })}
                </Button>
              </div>
              <div className="buttons_right_div">
                <div className="manger_sel">
                  <Select
                    mode="multiple"
                    onChange={value => {
                      this.setState({ selectedManager: value.join(SEMICOLON) });
                    }}
                    placeholder={intl.formatMessage({
                      id: 'room_manage_choose_meetingroom_admin'
                    })}
                  >
                    {meetingMangerOpts}
                  </Select>
                </div>
                <Button className="bind_btn" style={{fontWeight:'blod'}} onClick={this.bindRoomsManager}>
                  {intl.formatMessage({ id: 'room_manage_bind' })}
                </Button>
                <div className="input_search">
                  <Input.Search
                    placeholder={intl.formatMessage({
                      id: 'room_manage_list_name'
                    })}
                    onSearch={value => {
                      this.props.dispatch({
                        type: 'account/findRooms',
                        payload: { zoneId: this.state.zoneId, name: value }
                      });
                    }}
                    onChange={e => {
                      this.setState({ name: e.target.value });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="right_table">
            <Table
              rowKey={record => record.id}
              dataSource={rooms}
              columns={columns}
              rowSelection={rowSelection}
              pagination={{ pageSize: 10 }}
            />
          </div>
        </div>
        <RoomQrModal
          visible={showQr}
          currentRoomInfo={currentRoomInfo}
          onClose={this.onToggleQr}
          intl={this.props.intl}
        />
        <RoomDeviceModal
          visible={showDevice}
          currentRoomInfo={currentRoomInfo}
          onClose={this.onHideDevice}
          intl={this.props.intl}
        />
        <RoomMaintainModal
          visible={showMaintain}
          currentRoomInfo={currentRoomInfo}
          onClose={this.onHideMaintain}
          intl={this.props.intl}
        />
      </div>
    );
  }

  onShowDevice = room => {
    const { deviceIds = '' } = room;
    if (deviceIds) {
      this.setState({
        currentRoomInfo: room,
        showDevice: true
      });
    }
  };
  onHideDevice = () => this.setState({ showDevice: false });

  onShowMaintain = room => {
    this.setState({
      currentRoomInfo: room,
      showMaintain: true
    });
  };
  onHideMaintain = () => this.setState({ showMaintain: false });

  onToggleQr = () => {
    this.setState({ showQr: !this.state.showQr });
  };
}

export default injectIntl(RoomManager);



// WEBPACK FOOTER //
// ./src/components/account/RoomManager.js